import styles from "./HeroBackground.module.css";
import MosaicBackdrop from "./MosaicBackdrop";

/**
 * Decorative hero backdrop: a server-rendered image behind the headline, lit
 * by a cursor-following spotlight. See MosaicBackdrop for the artwork rules.
 */
function HeroBackground({ banner }) {
  return (
    <div className={styles.backdrop}>
      <MosaicBackdrop banner={banner} />
    </div>
  );
}

export default HeroBackground;
